import { Checkbox, FormControlLabel } from "@mui/material";

type SelecionarSeletorCheckboxesProps = {
  handleSelect: () => void,
  value: string,
  checked: boolean,
  disabled: boolean
}

export default function SeletorCheckboxes({ handleSelect, value, checked, disabled }:SelecionarSeletorCheckboxesProps){
  return (
    <FormControlLabel
      value={value}
      control={
        <Checkbox
          disabled={disabled}
          onClick={handleSelect}
          checked={checked}
        />
      }
      label=""
      labelPlacement="end"
    />)
}
